import { generateTextRecommendationStream } from "../../utils/textRecommendation";
import { isVideo } from "../SelfServiceCampaignCreation/Previews/utils";
import { UpdateCampaignSchema } from "./entities/Campaign";

export function getShutterstockPreviewUrl(imageUrl) {
  if (imageUrl.includes("res.cloudinary.com")) {
    return imageUrl;
  }

  const fileType = isVideo(imageUrl) ? "video" : "image";
  return `https://res.cloudinary.com/dyiuxe5fa/${fileType}/fetch/${imageUrl}`;
}

export const getRandomIndex = (array) => {
  return Math.floor(Math.random() * array.length);
};

export const getRandomElement = (array) => array[getRandomIndex(array)];

export const getLanguageByLocale = (locale) => {
  if (locale.includes("en")) {
    return "English";
  }

  if (locale.includes("de")) {
    return "German";
  }

  if (locale.includes("es")) {
    return "Spanish";
  }

  return "German";
};

export const fetchRecommendationStream = async ({
  setLoading,
  setStreamedText,
  organization,
  userProfile,
  campaignData,
  newJobTitle,
  Actions,
  formality = "Sie"
}) => {
  if (typeof setLoading === "function") {
    setLoading(true);
  }

  if (typeof setStreamedText === "function") {
    setStreamedText("");
  }

  const { id: orgaId, name: orgaName } = organization || {};
  const { userId, userName } = userProfile || {};
  const { jobPostLink, locale } = campaignData || {};

  const language = getLanguageByLocale(locale || "de_DE");

  const generatedText = await generateTextRecommendationStream(
    {
      channel: "instagram",
      jobTitle: newJobTitle,
      jobPostingUrl: jobPostLink,
      orgaName: orgaName || "",
      orgaId: orgaId || "",
      userId: userId || "",
      userName: userName || "",
      language,
      formality
    },
    (currentText) => {
      if (typeof setStreamedText === "function") {
        setStreamedText(currentText);
      }
      if (typeof setLoading === "function") {
        setLoading(false);
      }
    }
  );

  Actions.setText({ long: generatedText.teaserText });
  return generatedText;
};

export function mapAssets({
  shutterStockVideos,
  shutterStockImages,
  uploadedAssets,
  imagesSearchId,
  videosSearchId
}) {
  return [
    ...uploadedAssets.map((asset) => ({
      url: asset,
      type: isVideo(asset) ? "video" : "image",
      source: "user",
      searchId: isVideo(asset) ? videosSearchId : imagesSearchId
    })),
    ...shutterStockImages.map((image) => ({
      url: image.assets.preview_1000.url,
      type: "image",
      source: "shutterstock",
      externalId: image.id,
      searchId: imagesSearchId
    })),
    ...shutterStockVideos.map((video) => ({
      url: video.assets.preview_mp4.url,
      type: "video",
      source: "shutterstock",
      externalId: video.id,
      searchId: videosSearchId
    }))
  ];
}

export function checkCampaignStatus(campaignData) {
  if (campaignData.status === "NEW") {
    return "DRAFT";
  }

  return campaignData.status;
}

export const mapCampaignData = (rawData) => {
  try {
    const mappedData = {
      ...rawData,
      ...(rawData.deployed && { deployed: rawData.deployed === "true" }),
      ...(rawData.campaignDuration && { campaignDuration: Number(rawData.campaignDuration) }),
      ...(rawData.lifeTimeBudget && { lifeTimeBudget: Number(rawData.lifeTimeBudget) }),
      ...(rawData.locations?.length > 0 && {
        locations: rawData.locations.map((location) => ({
          ...location,
          radius: Number(location.radius) || 0
        }))
      }),
      ...(rawData.isRemoteJob && { isRemoteJob: Boolean(rawData.isRemoteJob) })
    };

    return UpdateCampaignSchema.partial().parse(mappedData);
  } catch (error) {
    console.error("Campaign data validation failed:", error);
    throw new Error("Invalid campaign data structure");
  }
};

export const countShutterstockAssets = (usedAds) => {
  const imagePrice = 12;
  const videoPrice = 24;

  const imageSet = new Set();
  const videoSet = new Set();

  usedAds.forEach((ad) => {
    const { type, inputProps } = ad.mediaAssets.vertical;

    if (type === "image" && inputProps?.backgroundImage?.includes("shutterstock")) {
      imageSet.add(inputProps?.backgroundImage);
    }

    if (type === "video" && inputProps?.video?.includes("shutterstock")) {
      videoSet.add(inputProps?.video);
    }
  });

  const uniqueImageCount = imageSet.size;
  const uniqueVideoCount = videoSet.size;

  const shutterstockImagesPrice = uniqueImageCount * imagePrice;
  const shutterstockVideosPrice = uniqueVideoCount * videoPrice;

  const totalShutterstockAssetsPrice = shutterstockImagesPrice + shutterstockVideosPrice;

  return {
    shutterstockImages: uniqueImageCount,
    shutterstockVideos: uniqueVideoCount,
    shutterstockImagesUrls: Array.from(imageSet),
    shutterstockVideosUrls: Array.from(videoSet),
    shutterstockImagesPrice,
    shutterstockVideosPrice,
    totalShutterstockAssetsPrice
  };
};
